import { FormattedMessage } from 'react-intl';

import { MoneyWithDecimals } from '../../../ui/moneyWithDecimals/index';
import messages from '../OutstandingView.messages';
import styles from './OutstandingBalance.module.css';

const OutstandingBalance = ({
    outstandingBalance
}: {
    outstandingBalance: number;
}) => (
    <div className={styles.outstandingBalance}>
        <div className={styles.title}>
            <FormattedMessage {...messages.outstandingBalance} />
        </div>
        <div className={styles.money}>
            <MoneyWithDecimals value={outstandingBalance} />
        </div>
    </div>
);

// eslint-disable-next-line import/no-default-export
export default OutstandingBalance;
